import { cx, css } from "@adjust/libs/emotion";

export const testimonialItemCSS = css({
  minHeight: "384px",
  width: "100%",
  maxWidth: "640px",
  fontSize: "1em",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  margin: "auto",
});
